jQuery(document).ready(function () {
    if ($('.dnMobileBar').length) {
        $('.dnFooter').addClass('dnFooter-extend');
    }
});